module.exports = __webpack_public_path__ + "static/03-9f5746bb7e0d00a87db0ab4bd5956d19.jpg";